import React, {useEffect, useMemo} from "react";
import {shallowEqual, useDispatch, useSelector} from "react-redux";

import {useQNAUIContext} from "../../../contexts/QNAUIContext";
import {QNAFilter} from "../../modules/QNAFilter";
import {QNATable} from "../../modules/QNATable";
import * as uiHelpers from "../../modules/QNATable/ui.helpers";
import * as actions from "../../../../redux/modules/qna/actions";

export function QNAContainer() {
  const context = useQNAUIContext();
  const {columns} = uiHelpers;

  const props = useMemo(() => {
    return {
      queryParams: context.queryParams,
      setQueryParams: context.setQueryParams,
      onClick: (_, row) => context.openQNADetailDialog(row.id),
    };
  }, [context]);

  const {currentState} = useSelector((state) => ({currentState: state.qna}), shallowEqual);
  const {totalCount, qnaList, listLoading} = currentState;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.fetchQNAList(props.queryParams));
  }, [props.queryParams, dispatch]);


  return (
    <div className="flex-grow-1">
      {/* Start:: QNAFilter */}
      <div className="mb-10">
        <QNAFilter />
      </div>
      {/* End:: QNAFilter */}

      {/* Start:: QNATable */}
      <div className="mb-10">
        <QNATable
          columns={columns}
          qnaList={qnaList}
          totalCount={totalCount}
          listLoading={listLoading}
        />
      </div>
      {/* End:: QNATable */}
    </div>
  );
}
